export const SET_ENV = 'SET_ENV';
export const SET_APP_VERSION = 'SET_APP_VERSION';
